/**
 * Hosts the shared ReportViewer with externally-bound parameter values — the
 * platform-side body for a smart-page report embed (page-variable args) and a
 * dashboard report tile (criteria bindings, server-resolved). The bound
 * params override the report's own defaults via withFixedParams; the key
 * remounts the viewer whenever they change so a new selection / global value
 * re-runs the report.
 */
import { useMemo } from 'react'
import { ReportViewer, withFixedParams } from '@twasta/page-runtime/report'
import { makeReportRuntimeAdapter } from './ReportLivePreviewPane'

export default function ReportEmbedBody({
  project, objName, params,
}: {
  project: string
  objName: string
  /** Externally-resolved values keyed by prompt name (case-insensitive). */
  params?: Record<string, unknown>
}) {
  const paramsKey = JSON.stringify(params ?? {})
  const adapter = useMemo(() => {
    const base = makeReportRuntimeAdapter(project, objName)
    return params && Object.keys(params).length
      ? withFixedParams(base, params)
      : base
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [project, objName, paramsKey])
  return (
    <ReportViewer
      key={`${project}/${objName}/${paramsKey}`}
      project={project}
      objName={objName}
      adapter={adapter}
    />
  )
}
